/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { O as index$t } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import hideLoading$2 from './cn/index.js';
import hideLoading$1 from './dingTalk/index.js';
import hideLoading$3 from './panguMiniApp/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        dingTalk: hideLoading$1,
        windvane: {
            cn: hideLoading$2,
        },
        panguMiniApp: hideLoading$3,
    },
};
/**
 * 取消 Loading 提示
 * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
 * @param  {HideLoadingIOptions} [data]
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { hideLoading } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * hideLoading()
 *   .then(() => {
 *     console.log('success');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var hideLoading = extend(apiConfig, 
/** baseHideLoading 支持windvane容器、nebula容器、小程序容器 */
index$t);

export { hideLoading };
